import { createComponent, FelaComponent } from "react-fela";
import legalMenu from "~/data/legal-menu.json";
import footerData from "~/data/footer-data.json";

import { colors, gutters, layout } from "~/styleguide";
import { fluid } from "~/styleguide/utils";

import WordpressLink from "~/components/global/links";
import { ContentMaxWidth } from "~/components/layout/max-width";

const socialIconUrls = {
    facebook: "/social/facebook.svg",
    instagram: "/social/instagram.svg",
    twitter: "/social/twitter.svg",
    dribbble: "/social/dribbble.svg",
    youtube: "/social/youtube.svg",
    linkedin: "/social/linkedin.svg",
    spotify: "/social/spotify.svg"
};

export default function Colophon() {
    const { data: menu } = legalMenu;
    const { data: footer } = footerData;

    const year = new Date().getFullYear();

    return (
        <div style={{ background: colors.blue }}>
            <FelaComponent style={colophonContainerStyles}>
                <ContentMaxWidth
                    extend={{
                        minWidthTablet: { display: "flex" },

                        justifyContent: "flex-start",
                        alignItems: "center",

                        maxWidth: layout.navContentMaxWidth,

                        maxWidthTablet: {
                            textAlign: "center"
                        }
                    }}
                >
                    {/* Copyright */}
                    <FelaComponent
                        style={colophonItem}
                        className="copyright"
                        as="span"
                    >
                        &copy; {year} Revenue.io. All rights reserved.
                    </FelaComponent>

                    {/* Dynamic Footer Menu */}
                    <FelaComponent style={colophonNav} as="nav">
                        {menu &&
                            menu.items &&
                            menu.items.map(item => {
                                return (
                                    <WordpressLink
                                        url={item.url}
                                        label={item.title}
                                        skipLabel={true}
                                        key={item.ID}
                                    >
                                        <FelaComponent
                                            style={[colophonItem, colophonLink]}
                                            key={item.ID}
                                        >
                                            {item.title}
                                        </FelaComponent>
                                    </WordpressLink>
                                );
                            })}
                    </FelaComponent>

                    {/* Social links */}
                    {footer && footer.acf && renderSocialLinks(footer)}
                </ContentMaxWidth>
            </FelaComponent>
        </div>
    );
}

const renderSocialLinks = ({ acf }) => {
    return (
        <FelaComponent style={socialLinkNavStyles}>
            {acf.linkedin_url && (
                <SocialLink site="linkedin" href={acf.linkedin_url}>Revenue.io on LinkedIn</SocialLink>
            )}

            {acf.facebook_url && (
                <SocialLink site="facebook" href={acf.facebook_url}>Revenue.io on Facebook</SocialLink>
            )}

            {acf.twitter_url && (
                <SocialLink site="twitter" href={acf.twitter_url}>Revenue.io on Twitter</SocialLink>
            )}

            {acf.instagram_url && (
                <SocialLink site="instagram" href={acf.instagram_url}>Revenue.io on Instagram</SocialLink>
            )}

            {acf.youtube_url && (
                <SocialLink site="youtube" href={acf.youtube_url}>Revenue.io on Youtube</SocialLink>
            )}

            {acf.dribbble_url && (
                <SocialLink site="dribbble" href={acf.dribbble_url}>Revenue.io on Dribble</SocialLink>
            )}

            {acf.spotify_url && (
                <SocialLink site="spotify" href={acf.spotify_url}>Revenue.io on Spotify</SocialLink>
            )}
        </FelaComponent>
    );
};

const colophonNav = {
    display: "flex",

    maxWidthTablet: {
        justifyContent: "center",
        marginTop: 30
    }
};

const colophonItem = {
    fontSize: 14,
    lineHeight: "20px",
    listStyle: "none",

    minWidthTablet: {
        marginRight: 40
    },
    maxWidthTablet: {
        marginRight: 10
    }
};

const colophonLink = {
    color: colors.white,
    opacity: 1,
    transition: "opacity 250ms",
    ":hover": {
        opacity: .5
    }
};

const socialLinkNavStyles = {
    marginLeft: "auto",

    maxWidthTablet: {
        width: "100%",
        textAlign: "center",
        marginTop: 30
    }
};

const colophonContainerStyles = () => ({
    color: "white",
    extend: [
        fluid("paddingH", gutters.default),
        fluid("padding-top", { max: 18, min: 40 }),
        fluid("padding-bottom", { max: 16, min: 40 })
    ]
});

const SocialLink = createComponent(
    ({ site }) => ({
        display: "inline-block",
        height: 26,
        width: 26,
        borderRadius: "50%",
        marginLeft: 18,
        backgroundSize: "cover",
        textIndent: "-9999em",
        overflow: "hidden",
        color: "#fff",

        ":first-child": { marginLeft: 0 },

        transition: "transform 0.2s ease",
        willChange: "transform",
        backgroundImage: socialIconUrls[site] ? `url("${socialIconUrls[site]}")` : "none",

        whenActive: {
            transform: "scale(1.1)"
        }
    }),
    "a",
    ["href"]
);
